import { z } from "zod";

import { AGENT_IPC_PROTOCOL_VERSION } from "./protocol-version.constant";

/**
 * The common envelope every v2 IPC line carries: a literal `protocolVersion`
 * marker the host uses to choose between v1 and v2 parsers during the
 * transition window, and which gates against future v3+ rollouts.
 *
 * Each event variant `.extend()`s this with its `kind` discriminator and
 * payload. Using `.extend()` rather than `.merge()` preserves
 * `z.discriminatedUnion` compatibility (each variant remains a ZodObject
 * with a literal discriminator).
 */
export const AgentIpcEnvelopeBaseSchema = z.object({
  protocolVersion: z.literal(AGENT_IPC_PROTOCOL_VERSION)
});
